import { c as _c } from "react/compiler-runtime";
import type { HTMLAttributes, ReactElement } from 'react';
import { cn } from '#cn';
import { getToneClass, type TextTone } from './typography-tones';
type TextVariant = 'label' | 'caption' | 'body' | 'body-lg' | 'small' | 'micro';
type TextProps = HTMLAttributes<HTMLElement> & {
  variant?: TextVariant;
  tone?: TextTone;
  muted?: boolean;
  as?: 'p' | 'span' | 'div';
};
const variantClasses: Record<TextVariant, string> = {
  label: 'text-2xs font-bold uppercase tracking-widest',
  caption: 'text-2xs',
  body: 'text-sm',
  'body-lg': 'text-lg leading-relaxed',
  small: 'text-xs',
  micro: 'text-3xs'
};

/** Body copy styled by one of the named type `variant`s (`label` down to `micro`), with a semantic `tone`. */
export const Text = t0 => {
  const $ = _c(18);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      children,
      variant: t1,
      tone: t2,
      muted: t3,
      as: t4,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  const variant = t1 === undefined ? "body" : t1;
  const tone = t2 === undefined ? "default" : t2;
  const muted = t3 === undefined ? false : t3;
  const Tag = t4 === undefined ? "p" : t4;
  const t5 = variantClasses[variant];
  let t6;
  if ($[8] !== className || $[9] !== muted || $[10] !== t5 || $[11] !== tone) {
    t6 = cn(t5, getToneClass(tone, muted), className);
    $[8] = className;
    $[9] = muted;
    $[10] = t5;
    $[11] = tone;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== Tag || $[14] !== children || $[15] !== props || $[16] !== t6) {
    t7 = <Tag className={t6} {...props}>{children}</Tag>;
    $[13] = Tag;
    $[14] = children;
    $[15] = props;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};